"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledQueryListSectionSkeleton = exports.SectionLabelSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _searchPreviewProduct = require("@ori/search-preview-product");
var _styles = require("../styles");
var _constants = require("./constants");
const SectionLabelSkeleton = exports.SectionLabelSkeleton = (0, _mui.styled)(_styles.UnifiedSkeleton)({
  height: _constants.SECTION_LABEL_HEIGHT,
  width: _constants.SECTION_LABEL_WIDTH
});
const StyledQueryListSectionSkeleton = exports.StyledQueryListSectionSkeleton = (0, _mui.styled)(_searchPreviewProduct.QueryListSectionSkeleton)({
  [`.${_searchPreviewProduct.queryListSectionClasses.queries}`]: {
    flexWrap: 'wrap'
  }
});
